import React from 'react'
import { faLanguage } from '@fortawesome/free-solid-svg-icons'
import IconButton from '../IconButton'
import OpenMultiLanguage from '../Input/OpenMultiLanguage'
import { useTranslation } from 'react-i18next'
import { closeModal, openModal } from '../../services/ModalService'
import { usePluginContext } from '../../contexts/PluginContext'

type MultiLanguageIconProps = {
    multiLanguageValue?: string
    onMultiLanguageChange?: (property: string, value: string) => void
    property: string
    className?: string
}

const MultiLanguageIcon: React.FC<MultiLanguageIconProps> = ({
    multiLanguageValue = '{}',
    onMultiLanguageChange,
    property,
}) => {
    const { plugin } = usePluginContext()
    const { t } = useTranslation(['common'])
    const handleMultiLanguageSubmit = (newValue: string) => {
        if (onMultiLanguageChange) {
            onMultiLanguageChange(property, newValue)
        }
        closeModal()
    }

    const toggleModal = () => {
        openModal({
            heading: t('languages'),
            content: (
                <OpenMultiLanguage
                    onSubmit={handleMultiLanguageSubmit}
                    languages={plugin?.languages ?? []}
                    defaultValues={
                        multiLanguageValue
                            ? (JSON.parse(multiLanguageValue) as object)
                            : {}
                    }
                />
            ),
        })
    }

    return (
        <IconButton
            title={'MultiLanguage'}
            icon={faLanguage}
            color={'#2f2f2f'}
            onClick={toggleModal}
            style={{ display: 'inline', fontSize: '1.2rem' }}
        />
    )
}

export default MultiLanguageIcon
